import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'
import { useFlag } from '@calendly/feature-check-react'

import { ConfirmationRedesignFooterSection, CookieSettingsButton } from 'components/confirmation/layout'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { ErrorComponent } from 'components/error_component'

import PackageDetails from '../new_confirmation/package_details'
import { eventTypeSelector } from '../../../../root-api'

import { PersonalizedHeader } from './header'
import { Details } from './details'
import { Layout } from './layout'
import { MarketingBanner } from './marketing_banner'
import _ExperimentContainer from "index-ExperimentContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/index.js?styleId=ExperimentContainer";
import _Left from "index-Left.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/index.js?styleId=Left";
import _Right from "index-Right.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/index.js?styleId=Right";


const ExperimentContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ExperimentContainer",
  styles: _ExperimentContainer
})

const Left = /*#__PURE__*/styled('div', null, {
  displayName: "Left",
  styles: _Left
})

const Right = /*#__PURE__*/styled('div', null, {
  displayName: "Right",
  styles: _Right
})

export const PersonalizedConfirmation = () => {
  const isPhone = useDeviceType('isPhone')
  const isTabletDown = useDeviceType('isTabletDown')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const { showDetails } = useConfirmationPageData()
  const eventType = useSelector(eventTypeSelector)

  return (
    <Layout expanded hideBranding={bookingAppRedesign}>
      <ErrorComponent />
      <ExperimentContainer isTabletDown={isTabletDown} isPhone={isPhone}>
        {isPhone && <Right isPhone={isPhone}><PersonalizedHeader /></Right>}
        <Left isPhone={isPhone}>
          <Details />
        </Left>
        <Right isPhone={isPhone}>
          {!isPhone && <PersonalizedHeader />}
          <PackageDetails eventTypeUuid={eventType?.uuid} />
          {showDetails && <MarketingBanner />}
          {!bookingAppRedesign && <CookieSettingsButton />}
        </Right>
      </ExperimentContainer>
      {bookingAppRedesign && <ConfirmationRedesignFooterSection />}
    </Layout>
  )
}
